/* eslint-disable max-len */
import { CONTENT } from '@bitComponents/unifiedComponents/Stopper';
import {
  BUTTON_COLOR,
  BUTTON_WIDTH,
  BUTTON_HEIGHT,
} from '@bitComponents/unifiedComponents/Button';
import { USER_TYPE } from '../../../../bitConstants/constants';

import { URLS, mobileTariffs } from '../../errorTextsConstants';

export const getErrorToPrint = ( goToC2C ) => {
  return {
    common: {
      INCORRECT_PARAMS: {
        errorInfo: {
          buttons: mobileTariffs.showListButton,
        },
      },
      PRODUCT_REGISTERED: {
        errorInfo: {
          buttons: mobileTariffs.showListButton,
        },
      },
      NOT_ACTIVATABLE_LINES: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          buttons: [{
            color: BUTTON_COLOR.BLUE,
            label: 'Volver a mis productos',
            link: URLS.MY_PRODUCTS,
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
          }],
          title: 'No es posible generar tu pedido',
          msg: [
            'Tras revisar tu configuración te informamos que no tienes líneas móviles pendientes de activación.',
          ],
          errorName: 'sin lineas incluidas activables',
        },
      },
      INCORRECT_BISI_CHARS: {
        errorType: CONTENT.INFO_ALERT,
        errorInfo: {
          buttons: [{
            label: 'Llama gratis al 900106235',
            link: 'tel:900106235',
            forceExternal: true,     
            desktopProps: {
              size: {
                w: BUTTON_WIDTH.LIQUID_DOPPED,
                h: BUTTON_HEIGHT.REGULAR,
              },
            },
            color: BUTTON_COLOR.BLUE,
          }],
          title: 'No disponemos de los datos del representante legal.',
          msg: [
            'Puedes llamar gratis al 900106235 y un asesor comercial te ayudará a completar tu pedido. Sentimos las molestias.',
          ],
          errorName: 'error bisi chars',
        },
      },
      DEFAULT_ERROR: {
        errorInfo: {
          buttons: mobileTariffs.showListButton,
        },
      },
    },
    [`user_${USER_TYPE.TELCO}`]: {
    },
    [`user_${USER_TYPE.OPEN}`]: {
    },
  }
};
